import { combineReducers } from 'redux';
import charts from './charts';
import graphs from './graphs';

export default combineReducers({
  charts,
  graphs,
});



// WEBPACK FOOTER //
// ./src/reducers/components/index.js